import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function ResetPassword() {
    const [form, setForm] = useState({
      email: "",
      password: "",
      password_confirmation: "",
      token: "",
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
  
    // Extract token and email from URL query params
    useEffect(() => {
      const params = new URLSearchParams(location.search);
      setForm((f) => ({
        ...f,
        token: params.get("token") || "",
        email: params.get("email") || "",
      }));
    }, [location.search]);
  
    const handleChange = (e) => {
      setForm({ ...form, [e.target.name]: e.target.value });
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
      setSuccess("");
      setError("");
  
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/reset-password`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(form),
        });
  
        const data = await response.json();
  
        if (response.ok) {
          // Laravel returns { "status": "Password reset successful." }
          setSuccess(data.status || "Password reset successful! Redirecting...");
          setTimeout(() => navigate("/login"), 2000);
        } else {
          // On error Laravel may return { "message": "...error..." }
          setError(data.message || data.status || "Failed to reset password.");
        }
      } catch {
        setError("Network error. Please try again.");
      }
  
      setLoading(false);
    };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-2">
      <div className="bg-white rounded-xl shadow-md p-6 w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4 text-center">Reset Password</h2>
        {error && <div className="text-red-600 mb-2">{error}</div>}
        {success && <div className="text-green-600 mb-2">{success}</div>}
        <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
          <input
            type="email"
            name="email"
            placeholder="Email"
            className="border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            value={form.email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="New Password"
            className="border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            value={form.password}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password_confirmation"
            placeholder="Confirm New Password"
            className="border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            value={form.password_confirmation}
            onChange={handleChange}
            required
          />
          <button
            type="submit"
            className="bg-blue-700 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-800 transition-colors duration-200"
            disabled={loading}
          >
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
}